import { render, staticRenderFns } from "./StructureLineItem.vue?vue&type=template&id=fa1a34d0&scoped=true"
import script from "./StructureLineItem.vue?vue&type=script&lang=js"
export * from "./StructureLineItem.vue?vue&type=script&lang=js"
import style0 from "./StructureLineItem.vue?vue&type=style&index=0&id=fa1a34d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1a34d0",
  null
  
)

export default component.exports